export const TIME_FILTER_BUTTONS = ["День", "Тиждень", "Місяць", "Квартал", "Рік", "Увесь час"];
export const COUNTRIES_FILTER_BUTTONS = ["Всі", "Україна", "США", '', "Європа"];
